import { render, staticRenderFns } from "./FilterItemsSideLong.vue?vue&type=template&id=19ab5491&"
import script from "./FilterItemsSideLong.vue?vue&type=script&lang=js&"
export * from "./FilterItemsSideLong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRangeSlider } from 'vuetify/lib/components/VRangeSlider';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VBtn,VCheckbox,VIcon,VRadio,VRadioGroup,VRangeSlider,VSlider})
